import React from "react";
import styles from "./Form.module.scss";

const Privacy = () => (
  <div className={styles.privacy}>
    We will not share or sell your information with third party sites. For more
    information on privacy details, please go
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://sfserviceguide.org/"
    >
      {" "}
      here{" "}
    </a>
    to view.
  </div>
);

export default Privacy;
